import styled from "styled-components";

const LeftPartDescription = styled.div`
  font-size: 16px;
  font-weight: 800;
  text-transform: lowercase;
  margin-top: 10px;

  @media (max-width: 575px) {
    font-size: 12px;
    font-weight: 600;
    margin-top: 5px;
  }
`;
export default LeftPartDescription;
